//import Libraries
import React, { Component } from 'react';
import {connect} from 'react-redux';
import radium, {StyleRoot} from "radium";
import Timeline from 'react-dual-timeline';

//import Components
// import Language from '../../../language/language.json';
import HistoryCard from './HistoryCard/HistoryCard';

import * as aboutActions from '../actions/aboutActions'

//import Style classes
import './History.css';

class Greeting extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        this.props.onLoadHistories();        
    }

    render() {
        if(!this.props.histories) {
            return (
                <div className="History">
                </div>
            )
        }

        const historyCards = this.props.histories.map((obj, idx) => {
            return (
                <HistoryCard data={obj} lang={this.props.lang} key={idx} />
            )
        })
        return(
            <div className="History">
                <StyleRoot>
                    <Timeline
                        activeColor="white"
                        lineColor="#303030"
                        twoSidedOverlap={70}
                        circleWidth={15}
                        offsetHidden={40}
                        animations={false}
                    >
                        {historyCards}
                    </Timeline>
                </StyleRoot>
            </div>
        )

    }
}

const mapStateToProps = (state) => {
    return {
        histories : state.about.histories
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onLoadHistories : () => {
            dispatch(aboutActions.loadHistories());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(radium(Greeting));


// WEBPACK FOOTER //
// ./src/pages/About/History/History.js